import { eInternalOrderStatus } from '../../../enums/eInternalOrderStatus';
import { eOrderGroupCategory } from '../../../enums/eOrderGroupCategory';
import { eCurativeGrade } from '../../../enums/eCurativeGrade';
import { eTransactionCategory } from '../../../enums/eTransactionType';
import { eExternalOrderStatus } from '../../../enums/eExternalOrderStatus';
import { ILenderData } from '../../interfaces/ILenderInformation';
import { IAddressData } from '../../interfaces/IAddressResponse';
import { IClientData } from '../../interfaces/IClient';
import { FullNamePartyData, IPartyData, isBuyerBorrower } from '../../interfaces/IParty';

export interface ISearchOrderRequest {
  parties: IPartyData[]; // TODO this should be a party request
  propertyAddress: IAddressData;
  clientCompany: IClientData;
  closesOn?: string;
  createdAt: string;
  fileNumber: string;
  lenderCompany: ILenderData;
  loanNumber?: string;
  orderPhase: eInternalOrderStatus;
  externalStatus: eExternalOrderStatus;
  county: string;
  transactionCategory: eTransactionCategory;
  updatedAt?: string;
  id: string;
  curativeGrade: eCurativeGrade;
  orderGroupId?: string;
  orderGroupCategory?: eOrderGroupCategory;
  mobilityGroup?: IMobilityGroupData;
  externalPartyTransactionId?: string;
  isSpruce?: boolean;
}

export interface IMobilityGroupData {
  id: string;
  createdAt: string;
  updatedAt: string;
  externalId: string;
  clientId: string;
  programType: {
    name: string;
    label: string;
  };
  takeTitle: boolean;
}
export type ISearchOrderData = ISearchOrderRequest;

export const convertFromSearchOrderRequestToSearchOrderDataArray = (data: ISearchOrderRequest[]): ISearchOrderData[] =>
  data;

export const convertFromSearchOrderDataToSearchOrderRequestArray = (data: ISearchOrderData[]): ISearchOrderRequest[] =>
  data;

export const getBorrowerStringFromParties = (parties: IPartyData[]): string =>
  parties
    .filter(isBuyerBorrower)
    .map((b) => FullNamePartyData(b))
    .join(', ');
